var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppPage',{attrs:{"check-user-permission":false}},[_c('div',{staticClass:"title is-2"},[_vm._v("Você realmente deseja sair do sistema?")]),_c('b-button',{attrs:{"type":"is-danger"},on:{"click":_vm.logout}},[_vm._v("Sair")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }